import React from 'react';
import Lottie from 'react-lottie';
import animationData from './Driving_Car_Lottie.json';
import './Driving_Car_Lottie.css';

function DrivingCarLottie(props) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };

    return (
        <section className="main">
            <div className="success_div">
                <div className="Driving_car_Lottie_icon">
                    <Lottie options={defaultOptions} />
                </div>
                {props?.successText && <p className="success_text">{props.successText}</p>}
            </div>
        </section>
    );
}

export default DrivingCarLottie;
